import {FC, useContext} from 'react';
import {FabricTemplate} from '~/common/fabric/types';
import {OptionsGrid} from '~/QuickEcards/components/OptionsGrid/OptionsGrid';
import {TabsContainer} from '~/QuickEcards/components/TabsContainer/TabsContainer';
import {BottomSheetTabContext} from '~/QuickEcards/context/BottomSheetTabContext';
import {OverlayIcon, Tab} from '~/QuickEcards/types/misc';

export interface AssetGridProps {
  assets: OverlayIcon[] | FabricTemplate[];
  onAssetClick(id: string): void;
}

export const OptionsContents: FC<AssetGridProps> = ({assets, onAssetClick}) => {
  const {tab, resetBottomDrawer, handleStampClick} = useContext(BottomSheetTabContext);

  return (
    <div>
      <TabsContainer<Tab>
        activeTab={tab}
        tabs={['design', 'reveals', 'effects']}
        handleCloseClick={resetBottomDrawer}
        handleTabClick={(newTab) => handleStampClick(newTab)}
      />
      <OptionsGrid tab={tab ?? 'design'} assets={assets} onAssetClick={onAssetClick} />
    </div>
  );
};
